import { apiGet } from '../../api/client';
import type {
  SectorInsightsListResponse,
  SectorInsightsSourcesResponse,
  SectorInsightsStocksResponse,
} from './types';

// 권위: dashboard-api SectorInsightsController.
// envelope 언랩은 apiClient interceptor 가 처리.

const BASE = '/api/v1/sector-insights';

export async function getSectorInsightsList(
  q?: string
): Promise<SectorInsightsListResponse> {
  const trimmed = q?.trim();
  if (!trimmed) return apiGet<SectorInsightsListResponse>(BASE);
  const qs = new URLSearchParams();
  qs.set('q', trimmed);
  return apiGet<SectorInsightsListResponse>(`${BASE}?${qs.toString()}`);
}

export async function getSectorInsightsStocks(
  canonicalKey: string,
  page: number,
  size: number
): Promise<SectorInsightsStocksResponse> {
  const qs = new URLSearchParams();
  qs.set('page', String(Math.max(0, page)));
  qs.set('size', String(Math.max(1, Math.min(500, size))));
  return apiGet<SectorInsightsStocksResponse>(
    `${BASE}/${encodeURIComponent(canonicalKey)}/stocks?${qs.toString()}`
  );
}

export async function getSectorInsightsSources(
  canonicalKey: string
): Promise<SectorInsightsSourcesResponse> {
  return apiGet<SectorInsightsSourcesResponse>(
    `${BASE}/${encodeURIComponent(canonicalKey)}/sources`
  );
}
